import { useEffect } from "react";
import { useUser } from "../../atoms/user";
import { Text } from "../../elements";
import { removeLoginToken, setLoginToken } from "../../utils/localStorage";
import { useApi } from "../../api";
import { useNavigate, useSearchParams } from "react-router-dom";

export const PageSetTokenCallback = () => {
  const { getVerifyUserApi } = useApi();
  const { setUser } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    const token = searchParams.get("token");

    if (!token) {
      navigate("/login");
      return;
    }

    setLoginToken(token);

    const response = await getVerifyUserApi().catch(() => null);

    // Invalid login token.
    if (!response) {
      removeLoginToken();
      navigate("/login");
      return;
    }
    // User verified.
    setUser(response);
    const returnTo = searchParams.get("returnTo");
    const target =
      returnTo && URL.canParse(returnTo, window.location.origin)
        ? new URL(returnTo, window.location.origin)
        : null;
    navigate(
      target?.origin === window.location.origin ? `${target.pathname}${target.search}` : "/",
      { replace: true },
    );
  };

  return <Text>Processing SSO login...</Text>;
};
